<template>
    <div class="not-found-page">
        <div>
            <div class="not-found-text">
                404
            </div>
            <div class="not-found-text">
                <v-icon
                    color="red"
                    size="80"
                    class="mr-5">
                    warning
                </v-icon>

                Not Found
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style lang="scss" scoped>
.not-found-text{
    font-size: 80px;
    display: flex;
    justify-content: center;
}
.not-found-page{
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: azure;
}
</style>
